

export interface ISpecialLeave {
  specialLeaveID: number;
  name: string;
  description: string;
  editData: ISpecialLeave | null;
  validItem: any;
  isEdit(): boolean;
}


export class CSpecialLeave implements ISpecialLeave {
  public specialLeaveID = 0;
  public name = '';
  public description = '';
  public editData: ISpecialLeave | null = null;
  public validItem = null;
  public isEdit = (): boolean => this.editData !== null && this.name !== this.editData.name;
}
